/* ==========================================================================
   eco-quick-add.js — straight-to-cart quick add

   Load ONCE, globally, in layout/theme.liquid before </body>:
     <script src="{{ 'eco-quick-add.js' | asset_url }}" defer></script>

   Deliberately does NOT open the cart drawer. The point of the grid is to
   keep people adding; interrupting with a drawer stops that. Feedback is
   the button state plus the impact bar moving at the top of the page.

   It also does not request cart sections on add. Asking for the drawer
   section is what makes some themes pop it open. The cart count bubble is
   refreshed separately, on its own.

   impact-bar.js already patches window.fetch and watches /cart/add.js, so
   the meter updates on its own with no wiring between the two files.
   ========================================================================== */

(function () {
  "use strict";

  if (window.__ecoQuickAdd) return;
  window.__ecoQuickAdd = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var RESET_MS = 1600;

  /* ---- one polite announcer for screen readers ---- */
  var live = document.createElement("p");
  live.setAttribute("role", "status");
  live.setAttribute("aria-live", "polite");
  live.style.cssText =
    "position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap";
  document.addEventListener("DOMContentLoaded", function () {
    document.body.appendChild(live);
  });

  function state(btn, name) {
    btn.classList.remove("is-adding", "is-added", "is-error");
    if (name) btn.classList.add(name);
  }

  /* ---- refresh just the cart count, nothing else ---- */
  function refreshBubble() {
    var bubble = document.getElementById("cart-icon-bubble");
    if (!bubble) return;

    fetch(ROOT + "?sections=cart-icon-bubble")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data["cart-icon-bubble"];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.getElementById("shopify-section-cart-icon-bubble") || doc.body;
        bubble.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function add(btn) {
    var id = btn.getAttribute("data-variant-id");
    if (!id || btn.classList.contains("is-adding")) return;

    state(btn, "is-adding");
    btn.disabled = true;

    fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || "Could not add");
          return data;
        });
      })
      .then(function () {
        state(btn, "is-added");
        live.textContent = (btn.getAttribute("data-title") || "Item") + " added to cart.";
        refreshBubble();

        /* Belt and braces — impact-bar.js already sees the fetch above,
           but themes and apps listen for this too. */
        document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));

        setTimeout(function () {
          state(btn, null);
          btn.disabled = false;
        }, RESET_MS);
      })
      .catch(function (err) {
        state(btn, "is-error");
        live.textContent = "Could not add that item.";
        console.warn("[eco-quick-add]", err.message);
        setTimeout(function () {
          state(btn, null);
          btn.disabled = false;
        }, RESET_MS);
      });
  }

  /* Delegated, so cards rendered later still work */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-eco-add]");
    if (!btn) return;
    e.preventDefault();
    add(btn);
  });
})();
